import React, { useEffect } from 'react';
import Lenis from 'lenis';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Marquee from '../components/Marquee';
import Manifesto from '../components/Manifesto';
import GrowStory from '../components/GrowStory';
import NewArrivals from '../components/NewArrivals';
import LatestPosts from '../components/LatestPosts';
import Community from '../components/Community';
import Footer from '../components/Footer';
import ChatWidget from '../components/ChatWidget';
import SEO from '../components/SEO';

const Home = () => {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1.05 });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const onAnchor = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (a) {
        const el = document.querySelector(a.getAttribute('href'));
        if (el) {
          e.preventDefault();
          lenis.scrollTo(el, { offset: -70 });
        }
      }
    };
    document.addEventListener('click', onAnchor);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      delete window.__lenis;
      document.removeEventListener('click', onAnchor);
    };
  }, []);

  return (
    <div data-testid="home-page" className="bg-void">
      <SEO
        title="TerraFungi — Myciculture de Précision & Mycélium"
        description="Laboratoire français de myciculture : seringues de culture liquide, substrats stériles, kits prêts-à-pousser et accessoires de laboratoire. Expédition 48 h, souches testées sur agar."
        path="/"
        jsonLd={{
          '@context': 'https://schema.org',
          '@graph': [
            {
              '@type': 'Organization',
              '@id': `${window.location.origin}/#organization`,
              name: 'TerraFungi',
              url: window.location.origin,
              logo: `${window.location.origin}/brand/logo.png`,
              image: `${window.location.origin}/brand/logo.png`,
              description: 'Laboratoire français de myciculture de précision : mycélium, substrats stériles, kits et accessoires.',
              email: 'contact@terrafungi.fr',
              areaServed: 'FR',
              contactPoint: {
                '@type': 'ContactPoint',
                email: 'contact@terrafungi.fr',
                contactType: 'customer support',
                availableLanguage: ['French'],
              },
            },
            {
              '@type': 'WebSite',
              '@id': `${window.location.origin}/#website`,
              name: 'TerraFungi',
              url: window.location.origin,
              inLanguage: 'fr-FR',
              publisher: { '@id': `${window.location.origin}/#organization` },
              potentialAction: {
                '@type': 'SearchAction',
                target: {
                  '@type': 'EntryPoint',
                  urlTemplate: `${window.location.origin}/boutique?q={search_term_string}`,
                },
                'query-input': 'required name=search_term_string',
              },
            },
          ],
        }}
      />
      <Navbar />
      <Hero />
      <Marquee />
      <NewArrivals />
      <LatestPosts />
      <Manifesto />
      <GrowStory />
      <Marquee />
      <Community />
      <Footer />
      <ChatWidget />
    </div>
  );
};

export default Home;
